<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Channel Sku Mapping
      </div>
      <v-spacer></v-spacer>

      <v-btn
        small
        color="primary"
        @click="dialog = true"
        class="mr-4"
        v-if="
          checkPermission('app_ecom_vendors:fulfillment_channel_sku_mapping')
        "
        >Link Channel & SKU</v-btn
      >
      <v-btn
        color="green"
        dark
        small
        class="mr-4"
        @click="listPage"
        v-if="checkPermission('app_ecom_vendors:excel_details')"
      >
        List
      </v-btn>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-dialog
      v-model="dialog"
      max-width="650px"
      @keydown.esc="close"
      persistent
    >
      <v-card>
        <v-card-title class="pt-0 pb-0 pl-0">
          <v-toolbar flat style="height: 50px">
            <v-toolbar-title class="mb-2">
              Link Channel & SKU (Mapping)
              <i class="caption red--text ml-4"> * required field</i>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-divider class="mt-3"></v-divider>
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="pb-0 pl-2"
                  v-if="userCategory.user_category == 3"
                >
                  <v-select
                    v-model="client"
                    @focus="fetchClients"
                    label="Select client"
                    :rules="[
                      (v) => (v !== '' && v !== null) || 'client is required.',
                    ]"
                    class="required"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    hide-details
                    @input="getDropdown(client)"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="pb-0">
                  <v-select
                    v-model="channelName"
                    label="Channel"
                    :rules="[
                      (v) => (v !== '' && v !== null) || 'channel is required.',
                    ]"
                    class="required pb-0"
                    :items="channelList"
                    item-text="channel_name"
                    item-value="channel_name"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" class="pl-0">
                  <v-file-input
                    v-model="dataFile"
                    accept=".xlsx"
                    label="Upload your file"
                    clearable
                    class="mt-0 pt-0"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <v-row> </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6 pt-0">
          <v-btn
            small
            color="info"
            @click="download"
            :loading="downloadLoader"
            class="ml-4 mt-0"
            v-if="
              checkPermission(
                'app_ecom_vendors:fulfillment_unlinked_sku_download'
              )
            "
          >
            Download unlinked sku
          </v-btn>
          <v-btn small color="primary" @click="save" :loading="saveLoader">
            update
          </v-btn>
          <v-btn
            color="primary"
            small
            class="error"
            @click="(dialog = false), $refs.form.reset()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="_headers"
      :items="Channel"
      :loading="loader"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3" v-if="userCategory.user_category == 3">
                <v-autocomplete
                  v-model="client_id"
                  :items="clients"
                  outlined
                  dense
                  item-text="name"
                  item-value="id"
                  label="Client"
                  clearable
                  :loading="clientsLoader"
                  @focus="fetchClients"
                  @click:clear="clearInput('this.client_name')"
                  @input="getDropdown(client_id)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statusCodes"
                  outlined
                  v-model="status_code"
                  dense
                  label="Status"
                  @click:clear="clearInput('this.status_code')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="channelNameFilter"
                  label="Channel"
                  :items="channelList"
                  item-text="channel_name"
                  item-value="channel_name"
                  outlined
                  dense
                  @click:clear="clearInput('this.channelNameFilter')"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="channel_product_id"
                  label="Channel Product id"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="uniware_sku_code"
                  label="Sku Code"
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                :sm="userCategory.user_category == 3 ? '9' : '12'"
              >
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  color="primary"
                  class="v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary mr-2"
                  @click="sync"
                  :loading="syncButton"
                  style="float: right"
                  v-if="
                    checkPermission(
                      'app_ecom_vendors:fulfillment_channel_sku_sync'
                    ) &&
                    channelNameFilter &&
                    client_id
                  "
                  >Sync</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>

      <template v-slot:[`item.modified_date`]="{ item }">
        {{ item.modified_date | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client"
          : true;
      });
    },
  },
  data: () => ({
    total: 0,
    channel_product_id: null,
    uniware_sku_code: null,
    channelNameFilter: null,
    Channel: [],
    channelList: [],
    channelName: null,
    client: null,
    dialog: false,
    clientsLoader: false,
    client_id: null,
    clients: [],
    loader: false,
    options: {},
    status_code: null,
    dataFile: null,
    downloadLoader: false,
    saveLoader: false,
    syncButton: false,
    statusCodes: [
      {
        text: "UNLINKED",
        value: "UNLINKED",
      },
      {
        text: "LINKED",
        value: "LINKED",
      },
    ],
    headers: [
      {
        text: "Client",
        value: "client_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Channel Name",
        value: "channel_name",
        width: "100",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Channel Product Id",
        value: "channel_product_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Product Name",
        value: "product_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Seller Sku",
        value: "seller_sku_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Sku Code",
        value: "uniware_sku_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Modified By",
        value: "modified_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Modified Date",
        value: "modified_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
  }),

  created() {
    this.fetchClients();
    if (this.$store.getters.user.user_category == 1) {
      this.getDropdown(this.$store.getters.user.id);
      this.client_id = this.$store.getters.user.id;
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchChannel();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getChannelList",
      "fetchClient",
      "channelSkuMapping",
      "downloadChannels",
      "getChannelDropdown",
      "syncChannel",
    ]),
    sync() {
      this.syncButton = true;
      const payload = new FormData();
      if (this.$store.getters.user.user_category == 1) {
        this.client_id = this.$store.getters.user.id;
      }
      payload.append("client_id", this.client_id);
      payload.append("channel_name", this.channelNameFilter);

      this.syncChannel(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.syncButton = false;
        })
        .catch(() => {
          this.syncButton = false;
        });
    },
    getDropdown(id) {
      if (id)
        this.getChannelDropdown(id).then((res) => {
          this.channelList = res.data;
        });
    },
    listPage() {
      this.$router.push({
        name: "channelStatusList",
        params: {
          type: "channel_sku_mapping_upload",
        },
      });
    },
    fetchClients() {
      if (this.clients.length) return;

      if (this.userCategory.user_category === 3 && this.clients.length == 0) {
        this.clientsLoader = true;
        this.fetchClient({
          pagination: 0,
          fields: "id,name",
          service: "fulfillment_wid_last_mile,fulfillment",
        })
          .then((res) => {
            this.clientsLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientsLoader = false;
          });
      }
    },
    download() {
      if (!this.$refs.form.validate()) return;

      this.downloadLoader = true;
      const payload = new FormData();
      payload.append("client_id", this.client);
      payload.append("channel_name", this.channelName);
      this.downloadChannels(payload)
        .then((res) => {
          this.fileDownload(res);

          this.downloadLoader = false;
        })
        .catch(() => {
          this.downloadLoader = false;
        });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.saveLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.dataFile);
      payload.append("client_id", this.client);
      payload.append("custom_values", this.channelName);

      this.channelSkuMapping(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialog = false;
          this.saveLoader = false;
        })
        .catch(() => {
          this.saveLoader = false;
        });
    },
    fetchChannel() {
      this.loader = true;
      this.getChannelList({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.Channel = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.status_code = null;
      this.client_id = null;
      this.channelNameFilter = null;
      this.uniware_sku_code = null;
      this.channel_product_id = null;
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        status_code: this.status_code,
        client_id: this.client_id,
        channel_name: this.channelNameFilter,
        channel_product_id: this.channel_product_id,
        uniware_sku_code: this.uniware_sku_code,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      this.fetchChannel();
    },
  },
};
</script>
<style lang="scss">
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
</style>
